import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      {/* Logo */}
      <div className="footer-logo">
        <Link to="/" aria-label="Fenix Media — Home">
          <img src="images/logoinvtransparent.png" alt="Fenix Media" />
        </Link>
      </div>

      {/* Links */}
      <nav className="footer-links" aria-label="Footer">
        <ul className="footer-grid">
          <li className="footer-item">
            <Link to="/about" className="footer-link">
              About
            </Link>
          </li>
          <li className="footer-item">
            <Link to="/services" className="footer-link">
              Services
            </Link>
          </li>
          <li className="footer-item">
            <Link to="/contact" className="footer-link">
              Contact
            </Link>
          </li>
          <li className="footer-item">
            <Link to="/portfolio" className="footer-link">
              Portfolio
            </Link>
          </li>
        </ul>
      </nav>

      {/* Social */}
      <section className="social-media">
        <div className="social-media-wrap">
          <small className="website-rights">
            Copyright © 2025 Fenix Media - All rights reserved -{" "}
            <a href="./privacy">Privacy Policy</a>
          </small>
          <div className="social-icons">
            {/* If these go off-site, use <a> not <Link> */}
            <Link
              class="social-icon-link facebook"
              to="/"
              target="_blank"
              aria-label="Facebook"
            >
              <i class="fab fa-facebook-f" />
            </Link>
            <Link
              class="social-icon-link instagram"
              to="https://www.instagram.com/fenix.mtl/"
              target="_blank"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram" />
            </Link>
            <Link
              class="social-icon-link youtube"
              to="https://www.youtube.com/@fenix-media"
              target="_blank"
              aria-label="Youtube"
            >
              <i class="fab fa-youtube" />
            </Link>
            <Link
              class="social-icon-link twitter"
              to="/"
              target="_blank"
              aria-label="LinkedIn"
            >
              <i class="fab fa-linkedin" />
            </Link>
          </div>
        </div>
      </section>
    </footer>
  );
}
